import { createSlice } from "@reduxjs/toolkit";
import {
  getCostComponentsThunk,
  getCostComponentByIdThunk,
  createCostComponentThunk,
  updateCostComponentThunk,
  deleteCostComponentThunk,
} from "state/action/cost_component";

const asyncState = (data = null) => ({
  data,
  isPending: false,
  isFulfilled: false,
  isRejected: false,
  err: null,
});

const initialState = {
  getCostComponents: asyncState(),
  getCostComponentById: asyncState(),
  createCostComponent: asyncState(),
  updateCostComponent: asyncState(),
  deleteCostComponent: asyncState(),
  selectedCostComponent: null,
};

function makeCases(builder, thunk, stateKey) {
  builder
    .addCase(thunk.pending, (state) => {
      state[stateKey] = {
        data: null,
        isPending: true,
        isFulfilled: false,
        isRejected: false,
        err: null,
      };
    })
    .addCase(thunk.fulfilled, (state, action) => {
      state[stateKey] = {
        data: action.payload,
        isPending: false,
        isFulfilled: true,
        isRejected: false,
        err: null,
      };
    })
    .addCase(thunk.rejected, (state, action) => {
      state[stateKey] = {
        data: null,
        isPending: false,
        isFulfilled: false,
        isRejected: true,
        err: action.error.message,
      };
    });
}

export const costComponentSlice = createSlice({
  name: "costComponent",
  initialState,
  reducers: {
    setSelectedCostComponent: (state, action) => {
      state.selectedCostComponent = action.payload;
    },
    clearCreateCostComponent: (state) => {
      state.createCostComponent = asyncState();
    },
    clearUpdateCostComponent: (state) => {
      state.updateCostComponent = asyncState();
    },
    clearDeleteCostComponent: (state) => {
      state.deleteCostComponent = asyncState();
    },
  },
  extraReducers: (builder) => {
    makeCases(builder, getCostComponentsThunk, "getCostComponents");
    makeCases(builder, getCostComponentByIdThunk, "getCostComponentById");
    makeCases(builder, createCostComponentThunk, "createCostComponent");
    makeCases(builder, updateCostComponentThunk, "updateCostComponent");
    makeCases(builder, deleteCostComponentThunk, "deleteCostComponent");
  },
});

export const costComponentAction = {
  ...costComponentSlice.actions,
  getCostComponentsThunk,
  getCostComponentByIdThunk,
  createCostComponentThunk,
  updateCostComponentThunk,
  deleteCostComponentThunk,
};

export function selectCostComponent(state) {
  return state?.costComponent;
}

export default costComponentSlice.reducer;
